export const LOG_IN = "LOG_IN" as const;
export const LOG_OUT = "LOG_OUT" as const;
export const LOG_IN_SUCCESS = "LOG_IN_SUCCESS" as const;
export const UPDATE_PROFILE = "UPDATE_PROFILE" as const;
export const LANGUAGE = "LANGUAGE" as const;
export const ADD_HISTORY = "ADD_HISTORY" as const;
export const BACK_HISTORY = "BACK_HISTORY" as const;
export const SET_IS_MOBILE = "SET_IS_MOBILE" as const;
export const INTERFACE = "INTERFACE" as const;
export const MESSAGE = "MESSAGE" as const;
export const STORE_LAYERS = "STORE_LAYERS" as const;
export const SHOW_CANVAS_MENU = "SHOW_CANVAS_MENU" as const;
export const LOGO_PATH = "LOGO_PATH" as const;
export const MENU_TYPE = "MENU_TYPE" as const;
export const RELOAD_SIDEBAR = "RELOAD_SIDEBAR" as const;
export const GLOBAL_NOTIFICATION = "GLOBAL_NOTIFICATION" as const;
export const GLOBAL_NOTIFICATION_COUNT = "GLOBAL_NOTIFICATION_COUNT" as const;
export const SHOW_NOTIFICATION = "SHOW_NOTIFICATION" as const;
export const SHOW_HELP_SIDEBAR = "SHOW_HELP_SIDEBAR" as const;
export const SHOW_FAVORITES_SIDEBAR = "SHOW_FAVORITES_SIDEBAR" as const;
export const DASHBOARD_NOTIFICATION = "DASHBOARD_NOTIFICATION" as const;
export const PREVENT_SIDEBAR = "PREVENT_SIDEBAR" as const;
export const HIDE_PLATFORM_HEADER = "HIDE_PLATFORM_HEADER" as const;
export const SHOW_AI_CHAT = "SHOW_AI_CHAT" as const;
